import html from "./QuestionStep.html"
import { getDefaultSurveyQuestionResult } from "../../../components/Survey/Util/getDefaultSurveyQuestionResult";
import "../SurveyReactComponent"
import * as surveyResultHelper from "../../../helpers/surveyResultHelper"

var module = angular.module("ResearchKitApplicationModule");

module.directive("questionStep",
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}
);

module.controller("questionStepController", ["$scope", "$timeout",
	function ($scope, $timeout) {
		$scope.canShow = function () {
			return !$scope.stepManager.canAutoContinue();
		}

		$scope.questionDisabled = function () {
			return !$scope.stepManager.hasAnswer() || $scope.stepManager.answerIsInvalid();
		}

		let questionProps = null;
		$scope.getQuestionProps = function () {
			var newQuestionProps = {
				answerFormat: $scope.stepManager.step.answerFormat,
				result: $scope.stepManager.getChildResult($scope.stepManager.step.identifier),
				onResultChange: function (result) {
					$scope.stepManager.setChildResult($scope.stepManager.step.identifier, result);
					$scope.stepManager.resultDidChange();
					if ($scope.stepManager.shouldAutoContinue()) {
						$scope.stepManager.continue();
					}
					if (!$scope.$$phase && !$scope.$root.$$phase) {
						$scope.$apply();
					}
				},
				onEnterPressed: $scope.getEnterPressedHandler(),
				optional: $scope.stepManager.step.optional,
				placeholder: $scope.stepManager.step.placeholder,
				variant: $scope.stepManager.getFormStyle(),
				key: $scope.stepManager.step.identifier
			};

			if (!angular.equals(newQuestionProps, questionProps)) {
				questionProps = newQuestionProps;
			}
			return questionProps;
		}

		$scope.getEnterPressedHandler = function() {
			return function() {
				$scope.$apply(function() {
					$scope.stepManager.continue();
				});
			}
		}
	}
]);

module.factory("QuestionStepManager", ["StepManager", function (StepManager) {
	function QuestionStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
	}
	QuestionStepManager.prototype = Object.create(StepManager.prototype)

	QuestionStepManager.prototype.initializeResults = function (previousResult) {
		StepManager.prototype.initializeResults.call(this, previousResult);
		this.noPreviousAnswer = previousResult === undefined;

		if (!this.childResults.length) {
			this.childResults = [{
				Identifier: this.step.identifier,
				Type: this.step.answerFormat.type === "FileAnswerFormat" ? "FileResult" : "QuestionResult",
				StartDate: this.presentedDate
			}];
		}

		let defaultSurveyResult = getDefaultSurveyQuestionResult(this.step.identifier, this.step.answerFormat);
		if (defaultSurveyResult.Answer != undefined && (this.childResults[0].Answer == undefined || this.childResults[0].Answer == null)) { this.childResults[0].Answer = defaultSurveyResult.Answer; }
		if (defaultSurveyResult.Choices != undefined && (this.childResults[0].Choices == undefined || this.childResults[0].Choices == null)) { this.childResults[0].Choices = defaultSurveyResult.Choices; }
	};

	QuestionStepManager.prototype.answerIsInvalid = function () {
		var result = this.getChildResult(this.step.identifier);

		if (!result) return false;

		return result.invalid;
	}

	QuestionStepManager.prototype.hasAnswer = function () {
		const result = this.getChildResult(this.step.identifier);
		return surveyResultHelper.hasAnswer(result);
	};

	QuestionStepManager.prototype.canContinue = function () {
		return !this.answerIsInvalid() && (this.hasAnswer() || this.step.optional);
	};

	QuestionStepManager.prototype.canAutoContinue = function () {
		return this.noPreviousAnswer &&
			!this.step.answerFormat.defaultValue &&
			((this.step.answerFormat.type === 'TextChoiceAnswerFormat' && this.step.answerFormat.style === 'Single') || this.step.answerFormat.type === 'BooleanAnswerFormat');
	};

	QuestionStepManager.prototype.shouldAutoContinue = function () {
		return this.canAutoContinue() && this.hasAnswer();
	}

	return QuestionStepManager;
}]);